import { SHOW_SHAREPOST, HIDE_SHAREPOST, SHOW_SHARETO, HIDE_SHARETO, FILL_LIST, EMPTY_LIST, CHANGE_LIST } from "../actions/sharePost"

const initialState = {
    show: false,
    show2: false,
    list: []
}

export const showSharePostReducer = (state = initialState, action)  => {
    switch(action.type) {
        case SHOW_SHAREPOST:
            return { ...state, show: true }
        case HIDE_SHAREPOST:
            return { ...state, show: false }
        case SHOW_SHARETO:
            return { ...state, show2: true }
        case HIDE_SHARETO:
            return { ...state, show2: false }
        case FILL_LIST:
            return { ...state, list: [ ...action.payload ] }
        case EMPTY_LIST:
            return { ...state, list: [] }
        
        default: return state
    }
}